export default __webpack_public_path__ + "static/media/cart-bear.11999a17.png";